import React, { ReactElement } from "react";
import { Link } from "react-router-dom";
import { ListGroup, ListGroupItem } from "reactstrap";
import { formatDate } from "../utils/apiUtils";
import eventLogo from "../images/MIXOPIA_EVENT_BG_001.png";
import ForwardIcon from "./ForwardIcon";
import { EventSummaryModel, UserModel, State } from "./EventModel";

export interface EventsProps {
  events: EventSummaryModel[];
  user: UserModel;
}

const getEventLink = (e: EventSummaryModel, u: UserModel): string => {
  if (u && e.host.id === u.id) {
    return "/edit/" + e.id;
  }
  if (e.state === State.Finished) {
    return "/links/" + e.id;
  }
  return "/guest/" + e.id;
};

export const EventsList = (props: EventsProps): ReactElement => (
  <ListGroup>
    {props.events.map((e) => (
      <ListGroupItem
        key={e.id}
        tag={Link}
        to={getEventLink(e, props.user)}
        action
      >
        <div className="d-flex">
          <div className="pe-2">
            <img src={eventLogo} height="72px" alt="mixopia event" />
          </div>
          <div className="flex-fill">
            <h5 className="mb-0">
              <span className="body-copy-2 fw-bold">{e.name}</span>
            </h5>
            <div className="align-self-end">
              <div className="body-copy-2">{e.host.displayName}</div>
              <div className="body-copy-2">{formatDate(e.startTime)}</div>
            </div>
          </div>
          <div className="ms-auto">
            <ForwardIcon />
          </div>
        </div>
      </ListGroupItem>
    ))}
  </ListGroup>
);
